import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chat = _resolveComponent("chat")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_chat, {
      chatIdentifier: _ctx.$route.params.identifier,
      readTicket: _ctx.$router.currentRoute.value.name == 'readTicket'
    }, null, 8, ["chatIdentifier", "readTicket"])
  ]))
}